import React, { useState, useEffect } from 'react';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_green.css';
import 'flatpickr/dist/plugins/monthSelect/style.css';
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';
import {msmartAxios} from '../../api/axios';
import { NumericFormat } from 'react-number-format';
import { useAuthContext } from '../../hooks/useAuthContext';
import { useToast } from '../../context/ToastContext';
import { getErrorMessage } from '../../utils/errorMessage';
import { Skeleton } from '../../components/Skeleton';

function SalesTarget({ teamId }) {
  const {user} = useAuthContext();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [targetAmount, setTargetAmount] = useState('');
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const { notifySuccess, notifyError } = useToast();

  const getMonth = (date) => date.getMonth() + 1;
  const getYear = (date) => date.getFullYear();

  const fetchTarget = async () => {
    setLoading(true);
    try {
      const month = getMonth(selectedDate);
      const year = getYear(selectedDate);
      const res = await msmartAxios.post(`/api/msmart/get/sales-target/${teamId}`,{month, year} ,{
        headers: {accessToken: user.token}
      });
      setTargetAmount(res.data.targetAmount || '');
    } catch (err) {
      // No target saved for this month yet is a normal case; only surface real failures.
      setTargetAmount('');
      if (err?.response?.status !== 404) {
        notifyError(getErrorMessage(err, 'Unable to load the sales target.'));
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTarget();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const month = getMonth(selectedDate);
      const year = getYear(selectedDate);
      const res = await msmartAxios.post(`/api/msmart/post/sales-target/${teamId}`, {
        month,
        year,
        targetAmount
      }, {
        headers: {accessToken: user.token}
      });
      notifySuccess(res.data.message || 'Target saved');
      setTimeout(() => window.location.reload(), 800);
    } catch (err) {
      notifyError(getErrorMessage(err, 'Error saving target'));
      setSaving(false);
    }
  };

  return (
    <div className='my-3'>
      <label>Select Month & Year:</label>
      <Flatpickr
        value={selectedDate}
        onChange={(date) => setSelectedDate(date[0])}
        options={{
          plugins: [new monthSelectPlugin({ shorthand: true, dateFormat: "m/Y" })],
          disableMobile: true
        }}
        className='form-control mb-3'
      />

      <label>Target Amount (RM):</label>
      {loading ? <Skeleton height={38} radius={6} className="mb-3" /> : <NumericFormat
        className="form-control mb-3"
        value={targetAmount}
        thousandSeparator
        prefix="RM "
        allowNegative={false}
        decimalScale={2}
        fixedDecimalScale
        onValueChange={(values) => {
          setTargetAmount(values.value); // `values.value` = tanpa RM, tanpa koma
        }}
        placeholder="Eg. : RM 1,000.00"
      />}

      <div className="d-grid">
      <button className="btn btn-dark" onClick={handleSubmit} disabled={loading || saving}>
        {saving ? 'Saving...' : 'Save Target'}
      </button>
      </div>
    </div>
  );
}

export default SalesTarget;
